import fm from 'format-message';

export const formatInvalidZipWithExample = (example: string) =>
    fm('Enter a valid zip code in correct format ({ example }).', { example });

const errorMessages = {
    badInput: fm('Check the format and try again. Use only allowed characters.'),
    invalidAddress: fm('Please enter a valid address'),
    invalidCity: fm('Please enter a valid city'),
    invalidName: fm('Please enter a valid name'),
    invalidNumber: fm('Please enter a valid mobile number'),
    invalidOldPassword: fm('Current password was incorrect'),
    invalidZip: fm('Enter a valid zip code for your selected country.'),
    noMobilePhone: fm('Please add a phone number to your account'),
    notChecked: fm('Please check this box to continue.'),
    passwordMismatch: fm('Password mismatch'),
    patternMismatch: fm('Check the format and try again.'),
    somethingWentWrong: fm('Something went wrong...'),
    tooShort: fm('This value is too short. Enter more characters.'),
    typeMismatch: fm('Enter an email address with @ and a domain, for example name@example.com.'),
    valueMissing: fm('Please enter a value in this field.'),
};

export default errorMessages;
